// src/components/ProjectGallery.tsx
import React, { useState, useMemo, useRef, useLayoutEffect } from "react";

import projectImage from "../../assets/building.png";
import { PROJECTS } from "../../data/constants";

// ——— NotchButton ———
const NotchButton: React.FC<{
  label: string;
  isActive: boolean;
  onClick: () => void;
}> = ({ label, isActive, onClick }) => {
  const textRef = useRef<SVGTextElement>(null);
  const [boxW, setBoxW] = useState(0);

  // constants for height and notch depth
  const H = 52;
  const notch = 15;
  const paddingX = 40;  // px of horizontal padding

  // measure text width once it's rendered
  useLayoutEffect(() => {
    if (textRef.current) {
      const bw = textRef.current.getBBox().width + paddingX * 2;
      setBoxW(Math.ceil(bw));
    }
  }, [label]);

  // polygon points for a bottom-right cut
  const points =
    boxW > 0
      ? [
          `0,0`,                     // top-left
          `${boxW},0`,               // top-right
          `${boxW},${H - notch}`,    // down to notch start on right
          `${boxW - notch},${H}`,    // left to notch end on bottom
          `0,${H}`,                  // bottom-left
        ].join(" ")
      : "";

  return (
    <svg
      onClick={onClick}
      width={boxW || undefined}
      height={H}
      viewBox={`0 0 ${boxW || 1} ${H}`}
      style={{ overflow: "visible", cursor: "pointer", margin: "0.25rem" }}
      className={isActive ? "notch-btn active" : "notch-btn"}
    >
      {boxW > 0 && (
        <polygon
          points={points}
          fill="transparent"
          stroke="#033652"
          strokeWidth="2"
        />
      )}
      <text
        ref={textRef}
        x={(boxW || 0) / 2}
        y={32}
        textAnchor="middle"
        fontFamily="sans-serif"
        fontSize="18"
        fill="#033652"
        pointerEvents="none"
        className="font-inter text-[18px] "
      >
        {label}
      </text>
      <style>{`
        .notch-btn:hover polygon,
        .notch-btn.active polygon {
          fill: #033652;
        }
        .notch-btn:hover text,
        .notch-btn.active text {
          fill: #ffffff;
        }
      `}</style>
    </svg>
  );
};

const categories = [
  "All",
  "Commercial",
  "Residential",
  "Government",
  "Healthcare",
  "Education",
];



const ProjectGalleryDesktop: React.FC = () => {
  const [active, setActive] = useState("All");
  const filtered = useMemo(
    () =>
      active === "All"
        ? PROJECTS
        : PROJECTS.filter((p) => p.category === active),
    [active]
  );
 
  return (
    <section className="bg-[#F5F7FA] px-6 py-20 md:px-24">
      <h2 className="font-utility text-center text-[24px] md:text-[54px] font-[500] text-[#0A1E2D] leading-snug mx-auto">
        Discover Our Exceptional Glass Solutions, <br />
        Tailored To Every Industry. 
       
      </h2>

      {/* Tabs */}
      <div className="flex flex-wrap justify-center gap-[32px] mt-[62px]">
        {categories.map((cat) => (
          <NotchButton
            key={cat}
            label={cat}
            isActive={active === cat}
            onClick={() => setActive(cat)}
          />
        ))}
      </div>

      {/* Projects Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 mt-14">
        {filtered.map((project) => {
         
          return (
            <div
             
            >
              <img
                src={project.image ?? projectImage}
                alt={project.name}
                className="md:w-[424px] md:h-[638px] object-cover group-hover:opacity-90 transition"
              />
              <h4 className="font-inter mt-4 text-[24px] font-medium text-[#033652]">
                {project.name}
              </h4>
              <p className="font-inter text-[24px] font-normal text-[#4F7286]">
                {project.location}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ProjectGalleryDesktop;
